const ITEMS = ["Grow", "A Bloom", "B Bloom", "Bongo Bloom", "PK", "Compact", "Formulado con IA", "Efecto Buffer", "Efecto CO2"];

export const Leaf = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12 2C7 6 4.5 10 4.5 14a7.5 7.5 0 0 0 15 0C19.5 10 17 6 12 2Zm0 4.2V21M12 11l-3 2.5M12 15l3 2.5" stroke="#0E2A1C" strokeWidth="1.1" strokeLinecap="round" />
  </svg>
);

export const JMarquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="editorial-marquee" className="relative py-7 md:py-9 overflow-hidden bg-[#F6EEDC] border-y-4 border-[#F2B441]">
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className={`px-7 text-4xl md:text-6xl ${i % 3 === 1 ? "font-label text-[#1B3A8C]" : "font-serif-d font-black italic text-[#0E2A1C]"}`}>{t}</span>
            <Leaf className="w-7 h-7 text-[#3E8E3A]" />
          </span>
        ))}
      </div>
    </section>
  );
};
